module.exports = __webpack_public_path__ + "static/media/fix.a3b49e0f.png";